import { composeClassNames, getImageUrl } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import ContentSection from "src/components/ContentSection";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getOg from "src/functions/getOg";
import translate from "src/functions/translate";
import { sPageEvents } from "src/styles/sPageEvents.module.scss";

export default function Events() {
  const { locale: lang } = useRouter();
  const iframeRef = useRef(null);

  const ogData = getOg(
    lang,
    `website`,
    translate(`Vivido yoga retreats and stays`, lang),
    translate(
      `Unplug & reconnect with Vivido Yoga Retreats! Embark on a transformative journey in Europe, Middle East, Asia, or Africa.`,
      lang
    ),
    (function () {
      switch (lang) {
        case `cs`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-events-cs.jpg")
          );
        case `sk`:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-events-sk.jpg")
          );
        default:
          return (
            constants.Paths.appUrl +
            getImageUrl("/images/social/vivido-social-events-en.jpg")
          );
      }
    })()
  );

  useEffect(() => {
    const handleIframeMessage = (e) => {
      if (iframeRef.current.contentWindow === e.source) {
        iframeRef.current.height = `${e.data.height}px`;
        iframeRef.current.style.height = `${e.data.height}px`;
      }
    };

    const handleWindowEvents = () => {
      const offsetTop = 50;
      let paddingTop = offsetTop;
      const posFromTop =
        iframeRef.current.getBoundingClientRect().top + window.scrollY;

      if (posFromTop < window.scrollY) {
        paddingTop = window.scrollY - posFromTop + offsetTop;
      }

      const data = {
        offset: paddingTop,
        height: window.outerHeight,
      };

      if (
        window.scrollY +
          iframeRef.current.getBoundingClientRect().top +
          iframeRef.current.offsetHeight / 2 <
        window.scrollY
      ) {
        Object.assign(data, { action: "load-accommodation" });
      }

      iframeRef.current.contentWindow.postMessage(
        data,
        constants.Paths.villasResorts
      );
    };

    window.addEventListener("message", handleIframeMessage);
    ["scroll", "resize"].forEach((event) => {
      window.addEventListener(event, handleWindowEvents);
    });

    return () => {
      window.removeEventListener("message", handleIframeMessage);
      ["scroll", "resize"].forEach((event) => {
        window.removeEventListener(event, handleWindowEvents);
      });
    };
  }, []);

  return (
    <>
      <Headers data={ogData} />
      <Page className={composeClassNames([sPageEvents, "page-events"])}>
        <Header />
        <ContentSection fluid={`xl`}>
          <Heading type="h1" title={<Translate tKey={`Yoga stays`} />} />
          <Row>
            <Col>
              <iframe
                id="iframe-villasresorts"
                width="100%"
                height="1200"
                src={`${constants.Paths.villasResorts}joga`}
                ref={iframeRef}
              />
            </Col>
          </Row>
        </ContentSection>
        <Footer />
        <Footers />
      </Page>
    </>
  );
}
